module.exports = __webpack_public_path__ + "static/media/bck@2x.6c704037.png";